try {
  const container = document.querySelector(
    ".scrollbar-container .list-collections__scroller"
  );
  const movingElement = document.getElementById("MovingElement");
  const parentElement = document.querySelector(".custom_scroller");

  container.addEventListener("scroll", () => {
    const { scrollLeft, scrollWidth, clientWidth } = container;
    const scrolledPercentage = (scrollLeft / (scrollWidth - clientWidth)) * 100;
    const moveAmount =
      (scrolledPercentage / 100) *
      (parentElement.offsetWidth - movingElement.offsetWidth);
    const movePercentage =
      (moveAmount / (parentElement.offsetWidth - movingElement.offsetWidth)) *
      100;
    const maxMoveAmount =
      parentElement.offsetWidth - movingElement.offsetWidth / 2;
    const maxMovePercentage = (maxMoveAmount / parentElement.offsetWidth) * 100;
    const constrainedMovePercentage = Math.max(
      0,
      Math.min(movePercentage, maxMovePercentage)
    );
    const constrainedMoveAmount =
      (constrainedMovePercentage / 100) * maxMoveAmount;
    movingElement.style.marginLeft = `${constrainedMoveAmount}px`;
  });
} catch (e) {}

try {
  document
    .querySelector(".upsell-add-cart")
    .addEventListener("click", async function (e) {
      e.preventDefault();
      let vid = this.getAttribute("data-vid");
      let formData = {
        items: [
          {
            id: vid,
            quantity: 1,
          },
        ],
      };
      const res = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
              detail: {
                cart: response.json(),
                openMiniCart:
                  window.themeVariables.settings.cartType === "drawer" &&
                  this.closest(".drawer") === null,
              },
            })
          );
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    });
} catch (e) {}

var activeTags = [];
$(function () {
  $(".blog-filter-nav-category_wrap").click(function () {
    $(this).siblings(".blog-filter-nav-category_sublinks").slideToggle();
    $(this).toggleClass("active");
  });

  $(document).on(
    "click",
    ".blog-filter-nav-category_sublinks li",
    function (e) {
      e.preventDefault();
      // e.stopPropagation();
      var text = $(this).text().trim();
      if ($(this).hasClass("active")) {
        $(this).find("input")[0].checked = false;
        $(this).removeClass("active");
        activeTags = activeTags.filter((item) => item !== text);
        filterProducts(activeTags);
      } else {
        $(this).find("input")[0].checked = true;
        $(this).addClass("active");
        activeTags.push(text);
        filterProducts(activeTags);
      }
    }
  );

  function filterProducts(array) {
    $(".blog-article_link").removeClass("match");
    $(".blog-article_link").each(function (i, el) {
      $(array).each(function (index, item) {
        if ($(el).attr("data-tags").includes(item)) {
          $(el).addClass("match");
        }
      });
    });

    if ($(".blog-article_link").hasClass("match")) {
      $(".blog-articles").removeClass("show_all");
    } else {
      $(".blog-articles").addClass("show_all");
    }
  }

  $(".blog-filter-toggle").click(function () {
    $(".blog-filter").toggleClass("active");
    $(".blog-filter-overlay").toggleClass("active");
  });
  $(".blog-filter-header").click(function () {
    $(".blog-filter").removeClass("active");
    $(".blog-filter-overlay").removeClass("active");
  });

  $(".blog-filter-overlay").click(function () {
    $(".blog-filter").removeClass("active");
    $(".blog-filter-overlay").removeClass("active");
  });
});

